(function($) {

  'use strict';

  function Header() {

    var self = this,
      $el = null,
      $mainMenu = null,

      options = {
        example: null,
      };

    /**
     * Toggle menu
     */
    function toggleMenu() {
      $mainMenu.toggleClass('is-menu-open');
    }

    /**
     * Generic resize
     */
    function onResize() {
      // Example
      if (window.bp.getLastValue() !== window.bp.getValue()) {
        if (window.bp.getValue() === 'xl') {
          console.log('header, xl');
        }

        if (window.bp.getValue() === 'lg') {
          console.log('header, lg');
        }

        if (window.bp.getValue() === 'md') {
          console.log('header, md');
        }

        if (window.bp.getValue() === 'sm') {
          console.log('header, sm');
        }

        if (window.bp.getValue() === 'xs') {
          console.log('header, xs');
        }
      }
    }


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(opts) {
      // extends options
      for (var i in opts) { options[i] = opts[i]; }

      

      // Caching
      $el = options.$el;
      $mainMenu = $('.js-main-header');


      $('.toggle-menu').on('click', function(){
        toggleMenu();
      });

      // *************
      window.cache.$window.on('resize', Utils.debounce(onResize, 3000));
      // Initial call on load
      onResize();
    };

    self.initialize.apply(self, arguments);
    return self;
  }

  /* Namespace declaration */
  window.Header = Header;

}(jQuery));
